import type { BuildContext } from '../../types';
import type { PolygonIndex } from '../../../geo/polygonIndex';
import type { ReservedFootprint } from '../types';
import { planHogeHuis } from './hogeHuisPlan';
import { planDamrakBlocks } from './damrakPlan';
import { planOudezijdeBlocks } from './oudezijdePlan';
import { planOudeKerkSouthFronts } from './oudekerkSouthPlan';
import { planOudeKerkIsland } from './oudekerkIslandPlan';
import { planOudeKerkYard } from './oudekerkYardPlan';
import { planLucienProperties } from './lucienPropertiesPlan';
import { planSacramentsProperties } from './sacramentsPropertiesPlan';
import { planKalverCorner } from './kalverCornerPlan';
import { planMolMosterd } from './molMosterdPlan';
import { planRaamGardens } from './raamGardensPlan';
import { planBegijnhof } from './begijnhofPlan';

export function planSurveyedBlocks(
  ctx: Pick<BuildContext, 'layout' | 'site'>,
  buildable: PolygonIndex,
  reserved: readonly ReservedFootprint[]
) {
  const hogeHuis = planHogeHuis(ctx, buildable, reserved);
  reserved = [...reserved, ...hogeHuis.reserved];
  const damrak = planDamrakBlocks(ctx, buildable, reserved);
  const oudezijde = planOudezijdeBlocks(ctx, buildable, [...reserved, ...damrak.reserved]);
  const kerkSouth = planOudeKerkSouthFronts(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
  ]);
  const kerkIsland = planOudeKerkIsland(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
  ]);
  const lucien = planLucienProperties(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
  ]);
  const sacraments = planSacramentsProperties(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
  ]);
  const kalverCorner = planKalverCorner(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
    ...sacraments.reserved,
  ]);
  const molMosterd = planMolMosterd(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
    ...sacraments.reserved,
    ...kalverCorner.reserved,
  ]);
  const raamGardens = planRaamGardens(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
    ...sacraments.reserved,
    ...kalverCorner.reserved,
    ...molMosterd.reserved,
  ]);
  const begijnhof = planBegijnhof(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
    ...sacraments.reserved,
    ...kalverCorner.reserved,
    ...molMosterd.reserved,
    ...raamGardens.reserved,
  ]);
  const kerkYard = planOudeKerkYard(ctx, buildable, [
    ...reserved,
    ...damrak.reserved,
    ...oudezijde.reserved,
    ...kerkSouth.reserved,
    ...kerkIsland.reserved,
    ...lucien.reserved,
    ...sacraments.reserved,
    ...kalverCorner.reserved,
    ...molMosterd.reserved,
    ...raamGardens.reserved,
    ...begijnhof.reserved,
  ]);
  return {
    lots: [
      ...hogeHuis.lots,
      ...damrak.lots,
      ...oudezijde.lots,
      ...kerkSouth.lots,
      ...kerkIsland.lots,
      ...lucien.lots,
      ...sacraments.lots,
      ...kalverCorner.lots,
      ...molMosterd.lots,
      ...raamGardens.lots,
      ...begijnhof.lots,
      ...kerkYard.lots,
    ],
    reserved: [
      ...hogeHuis.reserved,
      ...damrak.reserved,
      ...oudezijde.reserved,
      ...kerkSouth.reserved,
      ...kerkIsland.reserved,
      ...lucien.reserved,
      ...sacraments.reserved,
      ...kalverCorner.reserved,
      ...molMosterd.reserved,
      ...raamGardens.reserved,
      ...begijnhof.reserved,
      ...kerkYard.reserved,
    ],
    unresolved: [
      ...hogeHuis.unresolved,
      ...damrak.unresolved,
      ...oudezijde.unresolved,
      ...kerkSouth.unresolved,
      ...kerkIsland.unresolved,
      ...lucien.unresolved,
      ...sacraments.unresolved,
      ...kalverCorner.unresolved,
      ...molMosterd.unresolved,
      ...raamGardens.unresolved,
      ...begijnhof.unresolved,
      ...kerkYard.unresolved,
    ],
  };
}
